<template>
    <div class="main">
        <div style="color:#fff; margin-left: 20px;">校服V2.0系统功能列表</div>
        <div>
            <userInfo />
        </div>
    </div>
</template>
<script>
import userInfo from '../components/userInfo.vue';
export default {
    name:'Herder',
    data(){
        return{

        }
    },
    methods: {
    },
    components:{
        userInfo
    }    
}
</script>
<style lang="scss" scoped>
.main{
    background-color: #63CB63;
    font-size: 20px;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    padding-right: 10PX;
}

</style>